const Empty = () => null;

export default Empty;



// WEBPACK FOOTER //
// ./src/app/components/dynamicImport/Empty.jsx